import React, { useState } from "react";
import { InputGroup } from "react-bootstrap";

function AddTaskForm({ addTask, placeholder }) {
  const [value, setValue] = useState("");
  const handleSubmit = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      if (value) {
        addTask(value);
      }
      setValue("");
    }
  };

  const handleClickSubmit = (event) => {
    event.preventDefault();
    if (value?.trim())
      value.split(",").forEach((item) => {
        addTask(item);
      });

    setValue("");
  };

  return (
    <InputGroup>
      <input
        className="form-control"
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={(e) => setValue(e.target.value.replace(/@/g, ""))}
        onKeyUp={handleSubmit}
      />
      <InputGroup.Text onClick={handleClickSubmit} className="cursor-pointer">
        <i className="fa-regular fa-circle-plus" />
      </InputGroup.Text>
    </InputGroup>
  );
}

export default AddTaskForm;
